import { ItemFilterLabels } from 'enums/itemFilters';
import {} from 'interfaces/itemFilters';
export const isPaymentFilter = (filter) => filter.label === ItemFilterLabels.PAYMENT_ID;
